import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'; // 👈 hinzufügen
import PlausibleAnalytics from './components/PlausibleTracker';
import ScrollToTop from './components/ScrollToTop';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<PlausibleAnalytics />
			<ScrollToTop />
			<App />
		</BrowserRouter>
	</React.StrictMode>
);

reportWebVitals();
